import { TimeBasedSettingBaseDto, TimeBasedSettingBaseDtoImpl } from './timebasedsettingbasedto';

export interface TimeBasedSettingForCallersGroupDto extends TimeBasedSettingBaseDto
{
    getGroupId(): string;
    getGroupName(): string;
    getGroupDesc(): string;
}

export class TimeBasedSettingForCallersGroupDtoImpl extends TimeBasedSettingBaseDtoImpl implements TimeBasedSettingForCallersGroupDto
{
    private groupId: string;
    private groupName: string;
    private groupDesc: string;
    
    setGroupId(groupId: string)
    {
        this.groupId = groupId;
    }
    getGroupId(): string 
    {
        return this.groupId;
    } 

    setGroupName(groupName: string)
    {
        this.groupName = groupName;
    }
    getGroupName(): string 
    {
        return this.groupName;
    }

    setGroupDesc(groupDesc: string)
    {
        this.groupDesc = groupDesc;
    }
    getGroupDesc(): string 
    {
        return this.groupDesc;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/timebasedsetting/timebasedsettingforcallersgroupdto.tsx